<div id="quota"
     #quota>
    <svg:svg preserveAspectRatio="xMaxYMax meet"
             style="
            margin: auto;
            background: transparent;
            display: block;
            shape-rendering: auto;
        "
             [attr.width]="svgWidth"
             attr.height="{{svgHeight}}px">
        <svg:g [attr.transform]="gaugePos">
            <svg:rect attr.width="{{outerWidth}}px"
                      attr.height="{{mySettings.height}}px"
                      [attr.rx]="radius"
                      [attr.fill]="mySettings.colors.back"
                      [attr.stroke]="mySettings.colors.back"
                      stroke-width="0.25px"
                      x="0"
                      y="0">
            </svg:rect>
            <svg:rect id="neededGauge"
                      width="0"
                      attr.height="{{mySettings.height}}px"
                      [attr.rx]="radius"
                      [attr.fill]="neededQuotaColor"
                      [attr.stroke]="mySettings.colors.back"
                      stroke-width="0.25px"
                      x="0"
                      y="0">
            </svg:rect>
            <svg:rect id="consoGauge"
                      width="0"
                      attr.height="{{mySettings.height}}px"
                      [attr.rx]="radius"
                      [attr.fill]="mySettings.colors.conso"
                      [attr.stroke]="mySettings.colors.back"
                      stroke-width="0.25px"
                      x="0"
                      y="0">
            </svg:rect>
            <svg:text [attr.transform]="leftLegendPos"
                      [attr.dx]="radius / 2"
                      [attr.dy]="'-7'"
                      [attr.fill]="mySettings.colors.legend.left"
                      class="left-legend">
                {{ leftLegend }}
            </svg:text>
            <svg:text [attr.transform]="rightLegendPos"
                      [attr.dx]="(-1 * radius) / 2"
                      [attr.dy]="'-7'"
                      [attr.fill]="mySettings.colors.legend.right"
                      class="right-legend">
                {{ rightLegend }}
            </svg:text>
        </svg:g>
    </svg:svg>
</div>
